import { computed, ref } from 'vue'

// One answer to "is a product modal on screen?", shared by both hosts. V1 keeps its open request in
// a module-level ref (ProductModalHost) and V2 keeps it in component data (V2ProductModalHost), so
// without this the upsell modal would need to know which checkout it was living in to find out.
//
// The upsell modal opens the product modal on top of itself for variant products, and hides itself
// while it is up rather than stacking two dialogs.
const open = ref(false)

export function useProductModalOpen() {
  return {
    productModalOpen: computed(() => open.value),
    setProductModalOpen(value) {
      open.value = Boolean(value)
    }
  }
}
